import { toast } from 'react-toastify';
import axios from "../axios-instance";
import { getHeaders } from "./getHeaders";

export const fetchAnalyticsData = async (token) => {
  try {
    const { data } = await axios.get(
      `/PromoterAnalyticsInfo`,
      {headers: getHeaders(token)}
    );

    if (data.result) {
      return data.result;
    } else {
      throw new Error(data.errorMessage);
    }
  } catch (error) {
    // no need toast for no user called code
    // const message = `Analytics data not received. ${error}` || 'Analytics data not received'
    // toast.error(message);
  } 
}
